import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIList from 'UIComponents/list/UIList';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { openNewTab } from 'ui-addon-upgrades/_core/common/navigation/url';
import { getAcademyTrialRedirectLink } from '../../../trial/utils';

const ActivationSuccessFooter = ({
  ctaText,
  showTrialLoadingState,
  onSuccess = () => {},
  upgradeData: {
    app,
    upgradeProduct
  }
}) => {
  const academySuccessButtonProps = app === 'learning-center' ? {
    external: true,
    // replace with getAcademyTrialRedirectLinkFromApiName when trialGuide supports apiNames
    href: getAcademyTrialRedirectLink(upgradeProduct) // href is required only for the external icon to show up

  } : undefined;

  const onSuccessHandler = () => {
    if (app === 'learning-center') {
      // replace with getAcademyTrialRedirectLinkFromApiName when trialGuide supports apiNames
      openNewTab(getAcademyTrialRedirectLink(upgradeProduct));
    }

    onSuccess();
  };

  return /*#__PURE__*/_jsx(UIDialogFooter, {
    align: "center",
    children: /*#__PURE__*/_jsx(UIList, {
      firstChildClassName: "m-bottom-3",
      style: {
        maxWidth: '350px'
      },
      children: showTrialLoadingState ? /*#__PURE__*/_jsx(UILoadingSpinner, {
        showLabel: true,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.loadingLabel"
        })
      }) : /*#__PURE__*/_jsx(UIButton, Object.assign({
        block: true,
        use: "primary",
        onClick: onSuccessHandler
      }, academySuccessButtonProps, {
        children: ctaText || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.activationModal.getStarted"
        })
      }))
    })
  });
};

export default ActivationSuccessFooter;